<template>
  <div id="box">
    <a-card style="box-sizing:border-box;border-radius: 0 !important;">

      <Header></Header>

      <div style="height: 80px"></div>

      <div style="width: 100%;" class="paydemo">
        <div class="paydemo_title">插入CA证书<i>(如图下图所示证书)</i>，点击开始检测</div>
        <img :src="jianceimg" class="jianceimg" >

<!--        -->

        <div style="display: flex;flex-direction: row;justify-content: center;padding-top: 80px">
          <a-button style="font-weight:bold;width: 200px;background-color:red;height: 40px;font-size: 15px;border:0;" type="primary" @click="handleSubmit"> 点击开始检测 </a-button>
        </div>

        <div style=" display: flex; flex-direction: row; justify-content: center; color:#132b75;line-height: 50px;cursor: pointer" @click="homepay">返回首页</div>

      </div>
    </a-card>
    <el-dialog title="检测中..." :visible.sync="dialogVisible" width="50%" >
      <div style="position: relative;">
        <el-table :key="two" :data="messagestwo" border fit highlight-current-row style="width: 100%;">
          <el-table-column label="检测结果" align="left">
            <template slot-scope="{row}">
              <span>{{ row.title }}</span>
            </template>
          </el-table-column>
        </el-table>
        <b v-if="tianshu < 30" style="line-height:20px;font-size: 10px;color: red;padding-left:10px;">此服务少于30天！请尽快续费此服务！</b>
        <el-button shape="round" v-if="buttonstate" class="paydemo-button" type="primary" style="background: #2882fe;border-color: #2882fe;" @click="fixinadvance()">点此订购</el-button>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button style="background: #2882fe;border-color: #2882fe;" type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>



    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/footer/index.vue";
import Header from "@/components/heard/index.vue";
import { order_checksn, conf_list,} from '@/api/manage' // 接口
import { encode } from '@/utils/base64'
import jianceimg from '@/assets/key_images.png'
export default {
  name: 'paytest',
  components: {Footer, Header},
  props: {},
  data() {
    return {
      URl:'',
      tianshu:365,
      dialogVisible:false,
      jianceimg:jianceimg,
      buttonstate:false,
      one:'101010',
      two:'202020',
      three:'3030303',
      messagesone:[],
      messagestwo:[],
      messagesthree:[],
      messages:'',
      projectname: '',
      checked1: false,
      // imgurl: require('@/assets/images/key.png'),
      // imgbg: require('@/assets/images/topbg.jpeg'),
      configdata: {}
    }
  },
  created() {
    if (!checkctl1('1.0.3.0', '1.0.3.0', '1.0.3.0')) {
      this.$alert(' 检测到您的电脑缺少必要的运行控件，点击前往下载安装控件后方可正常使用系统', '消息提示', {
        confirmButtonText: '前往下载',
        callback: action => {
          console.log(action)
          if (action == 'confirm') {
            if (process.env.NODE_ENV === 'production') {
              window.location.href = "/#/download";
            } else {
              window.location.href = "/#/download";
            }
          }
        }
      });
    } else {
      console.log("检测到控件安装正常，可以继续操作")
    }
    var configdata =  JSON.parse(localStorage.getItem('configdata'))
    this.configdata = configdata
  },
  methods: {
    homepay() {
      this.$router.push('/');
    },

    checkkey() {
      // 是否需要密码输入框
      window.common.pinCodelabel = ''
      //指定赢达信
      var keyvalue = "WinTrust Cryptographic Provider@TFTknP11.dll@WTSKFInterface.dll@admin@12345678@1@CSP@SM2";
      var values = keyvalue.split('@')
      window.common.keyDll = values[2]
      window.common.pinCode = values[4]
      window.common.devBrand = values[7]
      //指定初始化参数
      window.common.InitParam = '<?xml version=\\"1.0\\" encoding=\\"utf-8\\"?>' +
          '<authinfo><liblist>'
      var keyDllBase64 = encode('WTSKFInterface.dll')
      window.common.InitParam = window.common.InitParam + '<lib type=\\"SKF\\" version=\\"1.1\\" dllname=\\"' +
          keyDllBase64 + '\\" ><algid val=\\"SHA1\\" sm2_hashalg=\\"sm3\\"/></lib>'
      window.common.InitParam = window.common.InitParam + '<lib dllname=\\"\\" type=\\"CSP\\" version=\\"1.0\\"><algid val=\\"SHA1\\"/></lib>' + '</liblist></authinfo>'
      var err = IDA.Initialize(window.common.InitParam, window.common.keyDll)
      if (err != 0) {
        this.$alert('初始化制证控件失败，错误码：' + err + ' 错误信息：' + IDA.GetErrorMessage(IDA.GetErrorCode()), '错误提示')
        IDA.Finalize()
        return false
      }
      //屏蔽管理员key
      IDA.SetAdminDevLabel(window.common.adminKeyLabel)
      //GetDeviceListEx返回json格式字符串：设备名称name、设备标签label、设备序列号sn
      var devNameList = IDA.GetDeviceListEx()
      // console.log("设备列表" + devNameList)
      if (devNameList == '对象无效' || devNameList == 'Invalid object') {
        this.$alert('请检查设备是否连接正常、设备与选择的驱动是否匹配', '错误提示')
        IDA.Finalize()
        return false
      }
      if (!devNameList) {
        //this.$alert('请检查设备是否连接正常、设备与选择的驱动是否匹配', '错误提示')
        IDA.Finalize()
        return false
      }
      console.log(devNameList)
      //释放控件内存
      IDA.Finalize()
      return true;
    },
    handleSubmit() {
      this.buttonstate = false
      this.messagestwo = []
      if (!this.checkkey()) {
        this.$alert('未检测到CA设备，请检查设备是否连接正常！', '错误提示')
        return false
      }
      this.dialogVisible = true
      //指定初始化参数
      window.common.InitParam = '<?xml version=\\"1.0\\" encoding=\\"utf-8\\"?>' + '<authinfo><liblist>'
      var keyDllBase64 = encode('WTSKFInterface.dll')
      window.common.InitParam = window.common.InitParam + '<lib type=\\"SKF\\" version=\\"1.1\\" dllname=\\"' + keyDllBase64 + '\\" ><algid val=\\"SHA1\\" sm2_hashalg=\\"sm3\\"/></lib>'
      window.common.InitParam = window.common.InitParam + '<lib dllname=\\"\\" type=\\"CSP\\" version=\\"1.0\\"><algid val=\\"SHA1\\"/></lib>' + '</liblist></authinfo>'
      var err = IDA.RegisterParam(window.common.InitParam, '', true)
      if (err != 0) {
        this.$alert('初始制证控件化失败，错误码：' + err + ' 错误信息：' + IDA.GetErrorMessage(IDA.GetErrorCode()), '错误提示')
        IDA.Finalize()
        return
      }
      var certstr = IDA.GetCertLists('SC', '', '', '', 'CN=Private Certificate Authority Of NHSA SM2,O=NHSA,C=CN|CN=Certificate Authority Of NHSA SM2,O=NHSA,C=CN|CN=Certificate Authority Of Test NHSA SM2,O=NHSA,C=CN', -1)
      // console.log(certstr,'certscertscertscertscerts')
      // var begintime = '2023-20-20'
      // var expiretime = '2023-20-20'
      // var mchexpire = '2023-20-20'
      // var mchexpirerest = 29
      // this.buttonstate = true
      // this.messagestwo.push({"title": "证书状态：已罐装医保证书"})
      // this.messagestwo.push({"title": "CA介质状态：本系统订购,正常"})
      // this.messagestwo.push({"title": "CA介质状态：证书起始时间 "+ begintime})
      // this.messagestwo.push({"title": "CA介质状态：证书失效时间 "+ expiretime})
      // this.messagestwo.push({"title": "服务状态：服务到期时间 "+ mchexpire })
      // this.tianshu = mchexpirerest
      if(certstr == ''){
        this.buttonstate = false
        this.messagestwo.push({"title": "证书状态：未罐装医保证书"})
        return false
      }else {
        var certs = JSON.parse(certstr)
        // console.log(certs,'certscertscertscertscerts')
        var cert = certs[0].dn
        console.log()
        var s61 = cert.split(',')[5]
        if(s61 != ' S=61'){
          this.messagestwo.push({"title": "证书状态：非法证书"})
          this.buttonstate = false
          return  false
        }else{
          order_checksn({sn:certs[0].sn}).then(response => {
            // console.log(response.data,'response')
            this.buttonstate = true
            this.URl = response.data.servbuyurl
            this.tianshu = response.data.mchexpirerest
            if(response.data.isnowmch == 1){ //是从本系统购买证书
              var begintime =/\d{4}-\d{1,2}-\d{1,2}/g.exec(response.data.begintime)
              var expiretime =/\d{4}-\d{1,2}-\d{1,2}/g.exec(response.data.expiretime)
              var mchexpire =/\d{4}-\d{1,2}-\d{1,2}/g.exec(response.data.mchexpire)
              this.messagestwo.push({"title": "证书状态：已罐装医保证书"})
              this.messagestwo.push({"title": "CA介质状态：本系统订购,正常"})
              this.messagestwo.push({"title": "CA介质状态：证书起始时间 "+ begintime})
              this.messagestwo.push({"title": "CA介质状态：证书失效时间 "+ expiretime})
              this.messagestwo.push({"title": "服务状态：服务到期时间 "+ mchexpire })
              if(response.data.ismchexpire == 0){
                this.messagestwo.push({"title": "服务状态：剩余天数 "+ response.data.mchexpirerest })
              }else{
                this.messagestwo.push({"title": "服务状态：已过期天数 "+ response.data.mchexpirerest })
              }
            }else{
              this.messagestwo.push({"title": "证书状态：非本系统订购"})
            }
          })
        }
      }

    },
    fixinadvance(){
      window.open(this.URl, '_blank')
    },
  }
}
</script>

<style lang="css" scoped>
@import 'seal.css';

body {
  //background-color: #fff !important;
}
.ant-card,
.ant-card-bordered{
  background: transparent !important;
}
.ant-card-body{
  //background: red;

}

#box {
  background-image: url("../../assets/box_bg.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 100vh;
}

.jianceimg{
  display: block;
  width: 264px;
  height: 100px;
  margin: 50px auto 20px;
}
.paydemo_title{
  display: block;
  text-align: center;
  font-weight: bold;
}

.paydemo_title i{
  font-style: normal;
  font-size: 12px;
  color:#8C8C8C;
}

.paydemo{
  position: relative;
  margin-top:50px;
  background: transparent;
}

.paydemo-button{
  position: absolute;
  top: 5px;
  right: 10px;
  z-index: 999;
}
/*html, body, #app, #root{background: #f5f5f5 !important;}*/

/*.son{*/
/*  position: absolute;*/
/*  left: 52px;*/
/*}*/
b {
  color: #333;
}

#sealintro {
  text-align: center;
  margin-top: 20px;
  line-height: 2;
  font-size: 14px
}

.wps {
  display: flex;
  justify-content: center;
  /*background: #132b75;*/
  height: 110px;
  line-height: 110px;
  /*padding: 25px 0;*/
  text-align: center;
  /*background: -webkit-radial-gradient(circle, #fff, #64d1dd, #e86a43);  */
  /*background:white; background-image: linear-gradient(90deg, rgba(200,0,0,.5) 50%, transparent 0), linear-gradient( rgba(200,0,0,.5) 50%, transparent 0); background-size: 30px 30px;*/
}

.box-card {
  width: 480px;
  position: relative;
}

.box-card button{
  display: block;
  width: 100px;
  position: absolute;
  left: 50%;
  bottom: 20px;
  margin-left: -50px;
}


.boxw {
  display: block;
  width: 100px;
  height: 100px;
  font-size: 46px;
  font-weight: 500;
  font-family: Microsoft YaHei UI Light;
  border-radius: 15px;
}


.biaoti {
  display: flex;
  flex-direction: row;
  font-size: 35px;
  font-weight: bold;
  text-align: center;
  font-family: "黑体";
}

.shangpinbiaoti {
  font-size: 16px;
  font-weight: 700;
  color: #000000;
}


.ant-carousel >>> .slick-dots {
  height: auto;
}

.ant-carousel >>> .slick-slide img {
  border: 5px solid #fff;
  display: block;
  margin: auto;
  max-width: 60%;
}

.ant-carousel >>> .slick-thumb {
  bottom: -45px;
}

.ant-carousel >>> .slick-thumb li {
  width: 60px;
  height: 45px;
}

.ant-carousel >>> .slick-thumb li img {
  width: 100%;
  height: 100%;
  filter: grayscale(100%);
}

.ant-carousel >>> .slick-thumb li.slick-active img {
  filter: grayscale(0%);
}

#ok .ant-form-item-label label::after {
  content: '';
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
}

.displayssssss {
  display: flex;
  flex-direction: column;
  height: 100px;
  position: relative;
}

.displayssssss p {
  float: right;
  width: 300px;
  text-align: right;
  position: absolute;
  right: 0;
}

.dingwei {
  width: 300px;
  height: 170px;
  position: absolute;
  top: -4px;
  right: 310px;

}

.colwei {
  width: 300px;
  height: 120px;
  background: #f5f5f5;
}

.dingweisb {
  /*width: 157px;*/

  position: absolute;
  top: 162px;
  left: 731px;

}


.position {
  background: rgba(0, 0, 0, .7);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999 !important;
}

.position_cont {
  display: block;
  width: 500px;
  height: 200px;
  padding: 0 25px;
  box-sizing: border-box;
  background: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  border-radius: 5px;
  margin-top: -125px;
  margin-left: -225px;
  z-index: 1000 !important;
}

.position_conttit {
  display: block;
  height: 50px;
  font-size: 16px;
  font-weight: bold;
  line-height: 50px;
}

.position_content {
  display: block;
  height: 100px;
  color: #f00;
  font-weight: bold;
  font-size: 14px;
  line-height: 70px;
  padding: 15px 0;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}

.position_contbot {
  display: flex;
  justify-content: flex-end;
  height: 50px;
  font-size: 16px;
  font-weight: bold;
  line-height: 50px;
}

.position_contbot span {
  display: block;
  height: 35px;
  line-height: 20px;
  padding: 7px 25px;
  color: #fff;
  margin-top: 5px;
  border-radius: 5px;
  box-sizing: border-box;
  background: #4278ff;
}

.el-button--blue {
  color: #fff;
  background-color:#2882fe;
  border-color: #2882fe;
}

.el-message-box__btns .el-button--primary {
  color: #fff !important; /* 这里设置你想要的颜色 */
  border-color:  #2882fe !important; /* 按钮边框颜色 */
  background-color:  #2882fe !important; /* 按钮背景颜色 */
}

.el-button.is-plain:hover {
  color:  #2882fe; /* 鼠标悬浮时按钮颜色 */
  border-color:  #2882fe; /* 鼠标悬浮时边框颜色 */
}
</style>
